const prepareInfobox = (json) => {
  if (json.area) {
    json.area = `${Number(json.area).toLocaleString()} кв. км.`;
  }
  if (json.population) {
    json.population = Number(json.population).toLocaleString();
  }
  if (json.date) {
    json.date = (new Date(json.date)).toLocaleDateString('ru-RU');
  }
  return json;
};


const domain = (protocol) => {
  let is_develop = process.env.NODE_ENV === "development";
  let secure = is_develop ? '' : 's';
  let backend = is_develop ? '127.0.0.1:8002' : 'geopuzzle.org';
  return `${protocol}${secure}://${backend}`;
};


function shuffle(a) {
  for (let i = a.length; i; i--) {
    let j = Math.floor(Math.random() * i);
    [a[i - 1], a[j]] = [a[j], a[i - 1]];
  }
  return a;
}


export { prepareInfobox, domain, shuffle };
